import { UPGRADE_BANNER_TYPES } from '../../ums/types';
import getUpgradeBannerTranslations from './getUpgradeBannerTranslations';
export const validateUpgradePointType = upgradeConfig => {
  if (!Object.keys(UPGRADE_BANNER_TYPES).includes(upgradeConfig.pointType.toString())) {
    throw new Error('Validation error - incompatible point type', {
      cause: `${upgradeConfig.upgradeKey}: is declared with an incompatible point type "${upgradeConfig.pointType.toString()}"`
    });
  }
};
export const validateUpgradeBannerDescriptions = upgradeConfig => {
  const {
    bannerTitle,
    bannerSubtitle
  } = getUpgradeBannerTranslations(upgradeConfig.descriptions);
  if (!bannerTitle) {
    throw new Error('Validation error - missing BANNER_TITLE', {
      cause: `${upgradeConfig.upgradeKey}: is missing BANNER_TITLE`
    });
  }
  if (!bannerSubtitle) {
    throw new Error('Validation error - missing BANNER_SUBTITLE', {
      cause: `${upgradeConfig.upgradeKey}: is missing BANNER_SUBTITLE`
    });
  }
};